//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import config from '../../config';
import { withStyles } from "@material-ui/core/styles";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import { schoolActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    contentRoot: {
        padding: theme.spacing(2),
        fontSize: 14,
        width: 600
    },
    actionRoot: {
        margin: 0,
        padding: theme.spacing(1)
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    tableImg: {
        width: '50px',
        height: '50px',
        position: 'relative',
        padding: '3px'
    },

    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    },
    borderedImgTable: {
        position: 'relative',
        width: '52px',
        height: '52px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '8px',
        marginRight: '8px'
    }
});

class School extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            advertisments: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            schoolAdd: false,
            categoryTitle: '',
            schoolError: '',
            schoolSuccess: '',
            getSchoolsList: [],
            addSchool: false,
            editingSchoolId: '',
            editingSchoolTitle: '',
            editingCatStatus: '',
            editingSchoolHold: false,
            perPage: config.perPageData,
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(schoolActions.getSchoolsList(apiConstants.GET_SCHOOL, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {

        const { dispatch } = props;
        if (props.deleteSchool.deleteSchool !== undefined &&
            props.deleteSchool.deleteSchool.data !== undefined &&
            props.deleteSchool.deleteSchool.data.data !== undefined &&
            props.deleteSchool.deleteSchool.data.success === true) {

            if (this.state.triggerDelete === true) {

                this.setState({ triggerDelete: false });
                this.setState({ deletingSchool: '', openDeleteSchool: false });

                let postData = {};
                postData.page = this.state.currentPage;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;
                dispatch(schoolActions.getSchoolsList(apiConstants.GET_SCHOOL, postData));

            }
        }

        //IF CATEGORY ADDED SUCCESSFULLY
        if (
            props.addSchool !== undefined &&
            props.addSchool.addSchool !== undefined &&
            props.addSchool.addSchool.data !== undefined &&
            props.addSchool.addSchool.data.success !== undefined &&
            props.addSchool.addSchool.data.success === true
        ) {
            const thisHolder = this;

            if (thisHolder.state.addSchool === true) {
                this.setState({ schoolSuccess: 'School added successfully!!', schoolError: '' });

                setTimeout(function () {
                    thisHolder.setState({ schoolSuccess: '', schoolError: '' });
                    thisHolder.closeAddCatPop();

                    let postData = {};
                    postData.page = thisHolder.state.currentPage;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = thisHolder.state.perPage;
                    dispatch(schoolActions.getSchoolsList(apiConstants.GET_SCHOOL, postData));

                }, 2000);
            }
        }


        // GET LIST OF CATEGORIES SUCCESS
        if (props.getSchoolsList !== undefined &&
            props.getSchoolsList.getSchoolsList.data !== undefined
        ) {
            const catDataReceived = props.getSchoolsList.getSchoolsList.data;
            this.setState({
                getSchoolsList: catDataReceived.data,
                totalPage: catDataReceived.data.totalPages,
                totalDataCount: catDataReceived.totalCount,
            })
        }

        // check if category is ready to edit
        if (props.getSchool !== undefined &&
            props.getSchool.editSchoolData !== undefined &&
            props.getSchool.editSchoolData.data !== undefined &&
            props.getSchool.editSchoolData.data.data !== undefined
        ) {
            const editingSchoolData = props.getSchool.editSchoolData.data.data;
            if (this.state.editingSchoolHold === true) {

                this.setState({
                    name: editingSchoolData[0].name,
                    address: editingSchoolData[0].address,
                    email_1: editingSchoolData[0].email_1,
                    email_2: editingSchoolData[0].email_2,
                    contact_no_1: editingSchoolData[0].contact_no_1,
                    contact_no_2: editingSchoolData[0].contact_no_2,
                    editingSchoolError: '',
                    editingSchoolSuccess: '',
                })
            }
        }


        // IF CATEGORY UPDATED SUCCESSFULLY
        if (
            props.addSchool !== undefined &&
            props.addSchool.addSchool !== undefined &&
            props.addSchool.addSchool.data !== undefined &&
            props.addSchool.addSchool.data.success !== undefined &&
            props.addSchool.addSchool.data.success === true
        ) {
            const thisHolder = this;
            //console.log("SSS", thisHolder.state.triggerEditSchool)
            if (thisHolder.state.triggerEditSchool === true) {

                this.setState({ editingSchoolError: '', editingSchoolSuccess: 'School updated succesfully!!' });
                const thisHolder = this;
                setTimeout(function () {

                    thisHolder.closeEditCatPop();

                    thisHolder.setState({ editingSchoolError: '', editingSchoolSuccess: '', triggerEditSchool: false });

                    let postData = {};
                    postData.page = thisHolder.state.currentPage;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = thisHolder.state.perPage;
                    dispatch(schoolActions.getSchoolsList(apiConstants.GET_SCHOOL, postData));


                }, 2000);
            }
        }

    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(schoolActions.getSchoolsList(apiConstants.GET_SCHOOL, postData));
    }


    // hit api and get category data for selected list range
    changeTableData = (e) => {
        const { dispatch } = this.props;

        this.setState({ perPage: parseInt(e.target.value) });

        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(schoolActions.getSchoolsList(apiConstants.GET_SCHOOL, postData));
    }

    /*
    * searchCategories - User can search data from the database and it will appear
    */
    searchCategories(keyword) {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(schoolActions.getSchoolsList(apiConstants.FIND_CATEGORIES, postData));
        } else {
            dispatch(schoolActions.getSchoolsList(apiConstants.GET_SCHOOL, postData));
        }
    }

    //on change set category title to state
    onChangeCatTitle = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }


    //close add category popup
    closeAddCatPop = () => {
        this.setState({
            schoolSuccess: '',
            schoolAdd: false,
            categoryTitle: '',
            addSchool: false
        });
    }

    //save category to collection
    handleSubmit = () => {
        const { dispatch } = this.props;
        this.setState({ schoolError: '' });
        const { name, address, email_1, email_2, contact_no_1, contact_no_2 } = this.state;
        if (name === undefined || name === '') { this.setState({ schoolError: 'name title required!!' }) }

        else {

            this.setState({ schoolError: '', addSchool: true })

            const postData = {};
            postData.name = name;
            postData.address = address;
            postData.email_1 = email_1;
            postData.email_2 = email_2;
            postData.contact_no_1 = contact_no_1;
            postData.contact_no_2 = contact_no_2;

            dispatch(schoolActions.saveSchool(apiConstants.SAVE_SCHOOL, postData));
        }

    }


    handleSubmitEditCat = () => {
        const { dispatch } = this.props;
        this.setState({ editingSchoolError: '' });
        const { name, address, email_1, email_2, contact_no_1, contact_no_2 } = this.state;
        if (name === undefined || name === '') { this.setState({ schoolError: 'name title required!!' }) }

        else {
            this.setState({ schoolError: '', addSchool: true })

            const postData = {};
            postData.schoolId = this.state.editingSchoolId;
            postData.name = name;
            postData.address = address;
            postData.email_1 = email_1;
            postData.email_2 = email_2;
            postData.contact_no_1 = contact_no_1;
            postData.contact_no_2 = contact_no_2;

            // update category data to cololection
            dispatch(schoolActions.saveSchool(apiConstants.UPDATE_SCHOOL, postData));
        }
    }


    // popup for editing the category
    editSchool = (schoolId) => {

        const { dispatch } = this.props;
        this.setState({
            editingSchoolId: schoolId,
            enableEditingSchool: true,
            editingSchoolError: '',
            editingSchoolSuccess: '',
            editingSchoolHold: true,
        });

        const postData = {};
        postData.schoolId = schoolId;

        dispatch(schoolActions.getSchoolById(apiConstants.GET_SCHOOL_BY_ID, postData));
    }

    closeEditCatPop = () => {
        this.setState({ editingSchoolId: '', enableEditingSchool: false, triggerEditSchool: false });
    }


    openAddSchool = () => {
        this.setState({
            schoolAdd: !this.state.schoolAdd,
            schoolSuccess: '',
            categoryTitle: '',
            parentcat: '',
            addSchool: false
        });

    }

    handleClose = () => {
        this.setState({ schoolAdd: !this.state.schoolAdd })
    };


    deletePopupOpen = (schoolId) => {
        this.setState({ deletingSchool: schoolId, openDeleteSchool: true });
    }

    closeDeletePopup = (schoolId) => {
        this.setState({ deletingSchool: '', openDeleteSchool: false });
    }

    // after conform click to delete cat
    deletingSchoolRecord = () => {
        this.setState({ triggerDelete: true });

        const { dispatch } = this.props;
        const postData = {};
        postData.schoolId = this.state.deletingSchool;
        dispatch(schoolActions.deleteSchool(apiConstants.DELETE_SCHOOL, postData));
    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { classes } = this.props;

        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    School
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800">School</h1>
                                <a href="javascript:void(0)"
                                    onClick={() => this.openAddSchool()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchCategories(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">Name</th>
                                                    <th scope="10%">Address</th>
                                                    <th scope="10%">Email</th>
                                                    <th scope="col">Contact Number</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {

                                                    this.state.getSchoolsList.data != undefined &&
                                                        this.state.getSchoolsList.data.length > 0 ?
                                                        this.state.getSchoolsList.data.map((thisCat, index) => {
                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thisCat.name}</td>
                                                                    <td>{thisCat.address}</td>
                                                                    <td>{thisCat.email_1}/{thisCat.email_2}</td>
                                                                    <td>{thisCat.contact_no_1}/{thisCat.contact_no_2}</td>
                                                                    <td>
                                                                        <a
                                                                            className="actionIcon"
                                                                            title="Edit"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.editSchool(thisCat._id)}
                                                                        ><span><img src="assets/img/svg/EditIcon.png" alt="Edit" /></span></a>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.deletePopupOpen(thisCat._id)}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="6" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add category popup */}
                    <Dialog
                        open={this.state.schoolAdd}
                        aria-labelledby="category-title"
                        aria-describedby="save-category-description"
                    >
                        <DialogTitle id="crop-image-dialog-title" className={classes.root}>Add School</DialogTitle>
                        <DialogContent className={classes.contentRoot}>
                            <div className="col-md-12 col-xs-12">
                                <p style={{ color: 'red' }}>{this.state.schoolError}</p>
                                <p style={{ color: 'green' }}>{this.state.schoolSuccess}</p>
                            </div>
                            <div class="row">
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Add School</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="Add School"
                                            className="form-control"
                                            name="name"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.schoolError}</p>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Address</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="Address"
                                            className="form-control"
                                            name="address"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Email 1</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="email_1"
                                            className="form-control"
                                            name="email_1"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Email 2</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="email_2"
                                            className="form-control"
                                            name="email_2"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Contact No 1</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="contact_no_1"
                                            className="form-control"
                                            name="contact_no_1"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Contact No 2</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="contact_no_2"
                                            className="form-control"
                                            name="contact_no_2"
                                        />
                                    </div>
                                </div>
                            </div>
                        </DialogContent>


                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeAddCatPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* edit category popup */}
                    <Dialog
                        open={this.state.enableEditingSchool}
                        aria-labelledby="edit-category-title"
                        aria-describedby="edit-category-description"
                    >
                        <DialogTitle id="crop-image-dialog-title" className={classes.root}>Edit</DialogTitle>
                        <DialogContent className={classes.contentRoot}>
                            <div className="col-md-12 col-xs-12">
                                <p style={{ color: 'red' }}>{this.state.editingSchoolError}</p>
                                <p style={{ color: 'green' }}>{this.state.editingSchoolSuccess}</p>
                            </div>
                            <div class="row">
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Add School</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="Add School"
                                            className="form-control"
                                            name="name"
                                            value={this.state.name !== undefined ? this.state.name : ''}
                                        />
                                        <p style={{ color: 'red' }}>{this.state.schoolError}</p>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Address</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="Address"
                                            className="form-control"
                                            name="address"
                                            value={this.state.address !== undefined ? this.state.address : ''}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Email 1</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="email_1"
                                            className="form-control"
                                            name="email_1"
                                            value={this.state.email_1 !== undefined ? this.state.email_1 : ''}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Email 2</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="email_2"
                                            className="form-control"
                                            name="email_2"
                                            value={this.state.email_2 !== undefined ? this.state.email_2 : ''}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Contact No 1</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="contact_no_1"
                                            className="form-control"
                                            name="contact_no_1"
                                            value={this.state.contact_no_1 !== undefined ? this.state.contact_no_1 : ''}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Contact No 2</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder="contact_no_2"
                                            className="form-control"
                                            name="contact_no_2"
                                            value={this.state.contact_no_2 !== undefined ? this.state.contact_no_2 : ''}
                                        />
                                    </div>
                                </div>
                            </div>

                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmitEditCat(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeEditCatPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* notify about delete */}
                    <Dialog open={this.state.openDeleteSchool} aria-labelledby="delete-tax-notify" >
                        <DialogTitle className={classes.root}>
                            {siteConstants.BTN_DELETE}
                        </DialogTitle>
                        <DialogContent>
                            {siteConstants.LABEL_SURE_DELTE_TAX_RECORD}
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingSchoolRecord(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>


                    <Footer />
                </div>



            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, addSchool, getSchoolsList, getSchool, editCategory, deleteSchool } = state;
    return {
        language,
        addSchool,
        getSchoolsList,
        getSchool,
        editCategory,
        deleteSchool

    };
}

export default connect(mapStateToProps)(withStyles(styles)(School));